<template>
	<v-dialog  
	 	v-model="dialog"
		:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		scrollable
		:max-width="fullscreen? null: maxWidth"
	>
		<!-- Актіватор -->
		<template v-slot:activator="{ on: dialog, attrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltip, attrs }">
					<slot name="activator" :attrs="attrs" :dialog="dialog" :tooltip="tooltip">
						<v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
							<v-icon>mdi-calculator-variant</v-icon>
						</v-btn>
					</slot>
				</template>
				<!-- <span>{{ $vuetify.lang.t(`$vuetify.${tooltip}`) | capitalize }}</span> -->
				<span>{{ title | capitalize }}</span>
			</v-tooltip>
		</template>

		<v-card>
			<!-- Ttoolbar -->
			<v-toolbar flat dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text>
				<v-form ref="form">
					<v-row>

		<!-- 
		$category 		= (int) $request->query->get('category', 13);
		$brand 			= (int) $request->query->get('brand');
		$model 			= (int) $request->query->get('model');
		$type 			= (int) $request->query->get('type');
		$year 			= (int) $request->query->get('year');
		$yearMin 		= (int) $request->query->get('yearMin');
		$yearMax 		= (int) $request->query->get('yearMax');
		$rating 		= (int) $request->query->get('rating');
		$ratingMin 		= (int) $request->query->get('ratingMin');
		$ratingMax 		= (int) $request->query->get('ratingMax');

		$datepriceMin 		= $request->query->get('datepriceMin');
		$datepriceMax 		= $request->query->get('datepriceMax');
		$dateprice_is_null 	= (bool) $request->query->get('dateprice_is_null', false);
		$dateprice_is_not_null 	= (bool) $request->query->get('dateprice_is_not_null', false);

		$offset 	= (int) $request->query->get('offset', 0);
		$limit 		= (int) $request->query->get('limit', 100);

		$order_by_expression 	= $request->query->get('order_by_expression', 'id');
		$order_by_direction 	= $request->query->get('order_by_direction', 'ASC');
		-->
						<v-col cols="12">
							<v-text-field
								v-model="item.year"
								label="Рік"
								clearable
							></v-text-field>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field
								v-model="item.yearMin"
								label="Рік, з"
								clearable
							></v-text-field>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field
								v-model="item.yearMax"
								label="Рік, по"
								clearable
							></v-text-field>
						</v-col>

						<v-col cols="12">
							<v-text-field
								v-model="item.rating"
								label="Рейтинг"
								clearable
							></v-text-field>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field
								v-model="item.ratingMin"
								label="Рейтинг, з"
								clearable
							></v-text-field>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field
								v-model="item.ratingMax"
								label="Рейтинг, по"
								clearable
							></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-radio-group v-model="item.dateprice_is_null" row>
								<template v-slot:label>
									<div>Ознака дати оцінки</div>
								</template>
								<v-radio :value="true">
									<template v-slot:label>
										<div>Оцинки не проводились</div>
									</template>
								</v-radio>
								<v-radio :value="false">
									<template v-slot:label>
										<div>Оцинки проводились</div>
									</template>
								</v-radio>
								<v-radio :value="null">
									<template v-slot:label>
										<div>Невизначено</div>
									</template>
								</v-radio>
							</v-radio-group>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field
								v-model="item.limit"
								label="Кількість рядків"
								type="number"
								clearable
							></v-text-field>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field
								v-model="item.offset"
								label="Сторінка"
								type="number"
								clearable
							></v-text-field>
						</v-col>
						
						<!-- <v-divider></v-divider> -->
						<v-col cols="12" md="6">
							<v-select
								v-model="item.order_by_expression"
								:items="order_by_expressions"
								label="Сортування"
								outlined
								dense
								hide-details="auto"
							></v-select>
						</v-col>
						<v-col cols="12" md="6">
							<v-select
								v-model="item.order_by_direction"
								:items="order_by_directions"
								label="Напрямок"
								outlined
								dense
								hide-details="auto"
							></v-select>
						</v-col>



		<!-- $dateprice_is_null 	= (bool) $request->query->get('dateprice_is_null', false);
		$dateprice_is_not_null 	= (bool) $request->query->get('dateprice_is_not_null', false);

		
		$limit 		= (int) $request->query->get('limit', 100);
		$offset 	= (int) $request->query->get('offset', 0);

		$order_by_expression 	= $request->query->get('order_by_expression', 'id');
		$order_by_direction 	= $request->query->get('order_by_direction', 'ASC'); -->

						<!-- <v-col cols="12" sm="6">
							<z-date
								v-model="item.datebegin"
								label="Дата початку періоду"
								outlined
								dense
								hide-details="auto"
							></z-date>
						</v-col>
						<v-col cols="12" sm="6">
							<z-date
								v-model="item.dateend"
								label="Дата завершення періоду"
								outlined
								dense
								hide-details="auto"
							></z-date>
						</v-col>
						<v-col cols="12" sm="6">
							<v-select
								v-model="item.type"
								:items="types"
								label="Тип"
								item-text="name"
								item-value="id"
								outlined
								dense
								hide-details="auto"
								return-object
								:rules="[rules.required, rules.onlyFromList]"
							>
								<template v-slot:item="{ on, item }">
									<v-list-item v-on="on">
										<v-list-item-content>
											<v-list-item-title>{{ item.name }}</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</template>
							</v-select>
						</v-col> -->
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK" :disabled="loading">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
import zDate from '@/views/components/control/Date'

export default {
	name: 'CatalogVehicleGenerateParam',
	mixins: [mixin],
	components: { zDate },
	data: () => ({
		item: {
			yearMin: 2010,
			ratingMax: 179,
			limit: 100,
			offset: 0,
			dateprice_is_null: true,
			order_by_expression: 'rating',
			order_by_direction: 'DESC',
		},

		loadings: {
			type: false,
			currency: false,
		},

		order_by_expressions: [
			{ text: 'Ідентифікатор', value: 'id' },
			{ text: 'Рейтинг', value: 'rating' },
		],

		order_by_directions: [
			{ text: 'Від меньшого до більшого', value: 'ASC' },
			{ text: 'Від більшого до меншого', value: 'DESC' },
		],
	}),

	props: {
		title: 				{ type: String, default: 'Визначення цін за параметрами' },
		icon: 				{ type: String, default: 'mdi-calculator-variant' },
		maxWidth: 			{ type: Number, default: 800 },

		category: 			{ type: Object, default: null },
		brand: 				{ type: Object, default: null },
		model: 				{ type: Object, default: null },
		modelYear: 			{ type: Number, default: null },
		type: 				{ type: Object, default: null },
	},

	computed: {
		...mapGetters('VehicleCategory', { categories: 'items' }),
		...mapGetters('VehicleBrand', { brands: 'items' }),
		...mapGetters('VehicleBrandModel', { models: 'items' }),
		...mapGetters('VehicleBrandModelYear', { years: 'items' }),
		...mapGetters('VehicleInsuranceType', { insuranceTypes: 'items' }),

		/* ...mapGetters('CurrencyType', { currencies: 'items' }),
		...mapGetters('CatalogVehiclePriceType', { types: 'items' }), */
	},

	created () {
		//console.log(this.$options.name, 'created')

		this.focusCategory()?.then(() => this.$set(this.item, 'category', this.categories[0]))

		/* this.focusCategory()?.then(() => this.$set(this.item, 'category', this.categories[0]))
		this.focusType()?.then(() => this.$set(this.item, 'type', this.types[0])) */

		/* this.$set(this.item, 'datebegin', (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10))
		this.$set(this.item, 'dateend', (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10))

		if(this.types.length == 0) {
			this.loadings.type = true
			this.loadType().then(() => this.$set(this.item, 'type', this.types[0])).finally(() => (this.loadings.type = false));
		}

		if(this.currencies.length == 0) {
			this.loadings.currency = true
			this.loadCurrency().then(() => this.$set(this.item, 'currency', this.currencies[2])).finally(() => (this.loadings.currency = false));
		} */
	},

	methods: {
		//...mapActions('CatalogVehiclePriceType', { loadType: 'load'}),
		...mapActions('CatalogVehicle', [ 'setItems' ]),
		...mapActions('CurrencyType', { loadCurrency: 'load'}),

		clearBrand () {
			this.$set(this.item, 'brand', null)
			this.setBrands()

			this.clearModel()
		},

		clearModel () {
			this.$set(this.item, 'model', null)
			this.setModels()
		},

		clearYear () {
			this.$set(this.item, 'yearProd', null)
			this.setYears()
		},

		onCategory (item) {
			this.clearBrand()
		},

		onBrand (item) {
			this.clearModel()
		},

		onModel (item) {
			this.clearYear()
		},
		onType (item) {
			//this.clearYear()
		},

		focusCategory(e) {
			/* if(this.categories.length == 0) {
				this.loadings.category = true
				return this.loadCategory(this.item).finally(() => (this.loadings.category = false));
			} */
		},

		focusBrand() {
			if(this.item?.category?.id && this.brands.length == 0) {
				this.loadings.brand = true
				return this.loadBrand(this.item).finally(() => (this.loadings.brand = false));
			}
		},

		focusModel() {
			if(this.item?.category?.id && this.item?.brand?.id && this.models.length == 0) {
				this.loadings.model = true
				return this.loadModel(this.item).finally(() => (this.loadings.model = false));
			}
		},

		focusYear() {
			if(this.item?.model?.id) {
				this.loadings.year = true
				return this.loadYear(this.item).finally(() => (this.loadings.year = false));
			}
		},

		focusType() {
			this.loadings.type = true
			return this.loadType(this.item).finally(() => (this.loadings.type = false));
		},

		onOpen () {
			//console.log('details.mixin.main', 'onOpen','selected', this.selected)

			if(this.selected?.id) {
				this.find(this.selected.id)
			} else {
				if(this.category) this.$set(this.item, 'category', this.category)
				if(this.brand) this.$set(this.item, 'brand', this.brand)
				if(this.model) this.$set(this.item, 'model', this.model)
				if(this.modelYear) this.$set(this.item, 'modelYear', this.modelYear)
				if(this.type) this.$set(this.item, 'type', this.type)
			}
		},

		onOK() {
			let that = this

			if(this.$refs.form.validate()) {
				this.loading = true
				axios.get(`/catalog/vehicle/price`, { params: this.item }).then(response => {
					//console.log(that.$options.name, 'onOpen','response.data', response.data)
					//that.json = response.data
					that.setItems(response.data)
					
				}, error => {
					console.log('error', error)
				}).finally(() => {
					this.loading = false
				});
				/* let p = this.id ? this.update(this.selected) : this.create();

				p.then(()=>{
					this.dialog = false
				}).finally(() => {
					this.loading = false
				}); */
				
				
			}
		},

		addPrice(item) {
			this.prices.push(item);
		},

		removePrice(item) {
			const index = this.prices.indexOf(item)
			this.prices.splice(index, 1);
		},

		/* onOpen (script) {
			console.log(this.$options.name, 'onOpen','item', this.item)

			this.script = script
			this.dialog = true
			this.loading = true
			let that = this
			axios.get(`/vehicle/request/${this.item.id}/averageprice/${this.script.code}/script`).then(response => {
				console.log(that.$options.name, 'onOpen','response.data', response.data)
				that.json = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => {
				this.loading = false
			});
		},

		copyText() {
			navigator.clipboard.writeText(this.$refs.script.textContent);
		} */
	},
}
</script>